document.addEventListener('click', function(e) {
  let item = e.target.closest('.doubly-nice-select .option');
  if (item) {
    let currency = item.getAttribute('data-value');
    let currentPath = window.location.pathname + window.location.search;
    console.log(item);

    if (currency === 'AED') {
      window.location.href = 'https://gameon.store' + currentPath;
    } else if (currency === 'SAR') {
      window.location.href = 'https://sa.gameon.store' + currentPath;
    } else if (currency === 'KWD') {
      window.location.href = 'https://kw.gameon.store' + currentPath;
    } else {
      window.location.href = 'https://gameon.store' + currentPath;
    }
  }
});

(() => {
  var e = {
          947: () => {
              Object.assign(NodeList.prototype, {
                  removeClass: function() {
                      for (const e of this) e.classList.remove(...arguments)
                  },
                  addClass: function() {
                      for (const e of this) e.classList.add(...arguments)
                  },
                  addEvents: function(...e) {
                      for (const t of this) t.addEvent(...e)
                  },
                  removeEvents: function(...e) {
                      for (const t of this) t.removeEvent(...e)
                  }
              }), Object.assign(HTMLCollection.prototype, {
                  removeClass: function() {
                      for (const e of this) e.classList.remove(...arguments)
                  },
                  addClass: function() {
                      for (const e of this) e.classList.add(...arguments)
                  },
                  addEvents: function(...e) {
                      for (const t of this) t.addEventListener(...e)
                  },
                  removeEvents: function(...e) {
                      for (const t of this) t.removeEventListener(...e)
                  },
                  forEach: Array.prototype.forEach
              }), Object.assign(HTMLElement.prototype, {
                  removeClass: function(...e) {
                      return this.classList.remove(...e), this
                  },
                  addClass: function(...e) {
                      return this.classList.add(...e), this
                  },
                  hasClass: function(e) {
                      return this.classList.contains(e)
                  },
                  css(e, t) {
                      this.style[e] = t
                  }
              }), Object.assign(Number.prototype, {
                  toCurrency: t
              }), Object.assign(String.prototype, {
                  toCurrency: t,
                  convertToSlug: function() {
                      let e = this;
                      return e = e.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, "a"), e = e.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, "e"), e = e.replace(/ì|í|ị|ỉ|ĩ/g, "i"), e = e.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, "o"), e = e.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, "u"), e = e.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, "y"), e = e.replace(/đ/g, "d"), e = e.replace(/\u0300|\u0301|\u0303|\u0309|\u0323/g, ""), e = e.replace(/\u02C6|\u0306|\u031B/g, ""), e.toLowerCase().replace(/-/g, " ").trim().replace(/[\(\)\[\]'"]/g, "").replace(/[^\w]+/g, "-")
                  }
              });
              var e = theme.currency.format;

              function t(t) {
                  let n = this;
                  n instanceof String && (n = n.replace(".", ""));
                  var o = "",
                      i = /\{\{\s*(\w+)\s*\}\}/,
                      s = t || e;

                  function r(e, t, n, o) {
                      if (n = n || ",", o = o || ".", isNaN(e) || null === e) return 0;
                      var i = (e = (e / 100).toFixed(t)).split(".");
                      return i[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + n) + (i[1] ? o + i[1] : "")
                  }
                  switch (s.match(i)[1]) {
                      case "amount":
                          o = r(n, 2);
                          break;
                      case "amount_no_decimals":
                          o = r(n, 0);
                          break;
                      case "amount_with_comma_separator":
                          o = r(n, 2, ".", ",");
                          break;
                      case "amount_no_decimals_with_comma_separator":
                          o = r(n, 0, ".", ",");
                          break;
                      case "amount_no_decimals_with_space_separator":
                          o = r(n, 0, " ");
                          break;
                      case "amount_with_apostrophe_separator":
                          o = r(n, 2, "'")
                  }
                  return s.replace(i, o)
              }! function() {
                  let e = window.fetch;
                  window.fetch = function(...t) {
                      let n = t[1] ? t[1].dataType : "";
                      return e(...t).then((async e => {
                          if (!e.ok && "basic" === e.type) throw await e.json();
                          switch (n) {
                              case "json":
                                  return e.json();
                              case "text":
                                  return e.text();
                              default:
                                  return e
                          }
                      }))
                  }
              }()
          }
      },
      t = {};

  function n(o) {
      if (t[o]) return t[o].exports;
      var i = t[o] = {
          exports: {}
      };
      return e[o](i, i.exports, n), i.exports
  }(() => {
      "use strict";
      n(947);
      var e = "data-section-id";

      function t(t, n) {
          this.container = function(t) {
              if (!(t instanceof Element)) throw new TypeError("Theme Sections: Attempted to load section. The section container provided is not a DOM element.");
              if (null === t.getAttribute(e)) throw new Error("Theme Sections: The section container provided does not have an id assigned to the data-section-id attribute.");
              return t
          }(t), this.id = t.getAttribute(e), this.extensions = [], Object.assign(this, function(e) {
              if (void 0 !== e && "object" != typeof e || null === e) throw new TypeError("Theme Sections: The properties object provided is not a valid");
              return e
          }(n)), this.onLoad()
      }
      t.prototype = {
          onLoad: Function.prototype,
          onUnload: Function.prototype,
          onSelect: Function.prototype,
          onDeselect: Function.prototype,
          onBlockSelect: Function.prototype,
          onBlockDeselect: Function.prototype,
          extend: function(e) {
              this.extensions.push(e);
              var t = Object.assign({}, e);
              delete t.init, Object.assign(this, t), "function" == typeof e.init && e.init.apply(this)
          }
      }, "function" != typeof Object.assign && Object.defineProperty(Object, "assign", {
          value: function(e) {
              if (null == e) throw new TypeError("Cannot convert undefined or null to object");
              for (var t = Object(e), n = 1; n < arguments.length; n++) {
                  var o = arguments[n];
                  if (null != o)
                      for (var i in o) Object.prototype.hasOwnProperty.call(o, i) && (t[i] = o[i])
              }
              return t
          },
          writable: !0,
          configurable: !0
      });
      var o = "data-section-type";
      window.Shopify = window.Shopify || {}, window.Shopify.theme = window.Shopify.theme || {}, window.Shopify.theme.sections = window.Shopify.theme.sections || {};
      var i = window.Shopify.theme.sections.registered = window.Shopify.theme.sections.registered || {},
          s = window.Shopify.theme.sections.instances = window.Shopify.theme.sections.instances || [];

      function r(e, n) {
          if ("string" != typeof e) throw new TypeError("Theme Sections: The first argument for .register must be a string that specifies the type of the section being registered");
          if (void 0 !== i[e]) throw new Error('Theme Sections: A section of type "' + e + '" has already been registered. You cannot register the same section type twice');

          function o(e) {
              t.call(this, e, n)
          }
          return o.constructor = t, o.prototype = Object.create(t.prototype), o.prototype.type = e, i[e] = o
      }

      function a(e, t) {
          e = d(e), void 0 === t && (t = document.querySelectorAll("[data-section-type]")), t = u(t), e.forEach((function(e) {
              var n = i[e];
              void 0 !== n && (t = t.filter((function(t) {
                  return !(c(t).length > 0) && (null !== t.getAttribute(o) && (t.getAttribute(o) !== e || (s.push(new n(t)), !1)))
              })))
          }))
      }

      function c(e) {
          var t = [];
          if (NodeList.prototype.isPrototypeOf(e) || Array.isArray(e)) var n = e[0];
          if (e instanceof Element || n instanceof Element) u(e).forEach((function(e) {
              t = t.concat(s.filter((function(t) {
                  return t.container === e
              })))
          }));
          else if ("string" == typeof e || "string" == typeof n) {
              d(e).forEach((function(e) {
                  t = t.concat(s.filter((function(t) {
                      return t.type === e
                  })))
              }))
          }
          return t
      }

      function l(e) {
          for (var t, n = 0; n < s.length; n++)
              if (s[n].id === e) {
                  t = s[n];
                  break
              } return t
      }

      function d(e) {
          return "*" === e ? e = Object.keys(i) : "string" == typeof e ? e = [e] : e.constructor === t ? e = [e.prototype.type] : Array.isArray(e) && e[0].constructor === t && (e = e.map((function(e) {
              return e.prototype.type
          }))), e = e.map((function(e) {
              return e.toLowerCase()
          }))
      }

      function u(e) {
          return NodeList.prototype.isPrototypeOf(e) && e.length > 0 ? e = Array.prototype.slice.call(e) : NodeList.prototype.isPrototypeOf(e) && 0 === e.length || null === e ? e = [] : !Array.isArray(e) && e instanceof Element && (e = [e]), e
      }

      function h(e, t) {
          if (null === t) return e;
          if ("master" === t) return p(e);
          const n = e.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
          if (n) {
              const o = e.split(n[0]),
                  i = n[0];
              return p(`${o[0]}_${t}${i}`)
          }
          return null
      }

      function p(e) {
          return e.replace(/http(s)?:/, "")
      }
      window.Shopify.designMode && (document.addEventListener("shopify:section:load", (function(e) {
          var t = e.detail.sectionId,
              n = e.target.querySelector('[data-section-id="' + t + '"]');
          null !== n && a(n.getAttribute(o), n)
      })), document.addEventListener("shopify:section:unload", (function(e) {
          var t = e.detail.sectionId,
              n = e.target.querySelector('[data-section-id="' + t + '"]');
          "object" == typeof c(n)[0] && c(n).forEach((function(e) {
              var t = s.map((function(e) {
                  return e.id
              })).indexOf(e.id);
              s.splice(t, 1), e.onUnload()
          }))
      })), document.addEventListener("shopify:section:select", (function(e) {
          var t = l(e.detail.sectionId);
          "object" == typeof t && t.onSelect(e)
      })), document.addEventListener("shopify:section:deselect", (function(e) {
          var t = l(e.detail.sectionId);
          "object" == typeof t && t.onDeselect(e)
      })), document.addEventListener("shopify:block:select", (function(e) {
          var t = l(e.detail.sectionId);
          "object" == typeof t && t.onBlockSelect(e)
      })), document.addEventListener("shopify:block:deselect", (function(e) {
          var t = l(e.detail.sectionId);
          "object" == typeof t && t.onBlockDeselect(e)
      })));









      class m extends HTMLElement {
          constructor() {
              super(), this.elms = {
                  form: this.querySelector("form"),
                  mainImage: this.querySelector(".product-card_media a img"),
                  price: this.querySelector(".product-price>.price>h1"),
                  comparedPrice: this.querySelector(".product-price>.price-compare>h5"),
                  blDisct: this.querySelector(".product-price .bl_disct"),
                  swatchImageInputs: this.querySelectorAll(".swatch-group input"),
                  atcButton: this.querySelector(".js-atc-btn"),
                  quickViewButton: this.querySelector(".js-product-card-quick-view")
              }, this.initATC(), this.initQuickView(), this.initSwatches()
          }
          initSwatches() {
              let {
                  mainImage: mi,
                  price: pr,
                  blDisct: bpr,
                  comparedPrice: cpr,
                  swatchImageInputs: sii
              } = this.elms;
              sii.forEach((e => {
                  e.addEvent("change", (function() {
                  //product-card--no-discounted
                      let media = e.dataset.variantMedia,
                      price = e.dataset.variantPrice,
                      comparedPrice = e.dataset.variantCprice;
                      //change varinat media
                      var mi_up = mi.getAttribute('data-srcset');
                      mi.srcset = media;
                      //change price
                      pr.innerHTML = price;
                      var price_in = Number(price.split(".")[0]);
                      var comparedPrice_in = comparedPrice.split(".")[0];
                      var new_compare_pri = Number(comparedPrice_in.replace(',', ''));

                      if (new_compare_pri <= price_in) {
                          //price
                          pr.classList.remove("price-sale");
                          //comparedPrice
                          cpr.classList.add("product-card--no-discounted");
                          cpr.innerHTML = '';
                          //blDisct
                          bpr.classList.add("product-card--no-discounted");
                          bpr.innerHTML = '';
                      } else if (new_compare_pri < price_in){
                          //price
                          pr.classList.add("price-sale");
                          //comparedPrice
                          cpr.classList.remove("product-card--no-discounted");
                          cpr.innerHTML = comparedPrice;
                          //blDisct
                          bpr.classList.remove("product-card--no-discounted");
                          bpr.innerHTML = ((new_compare_pri - price_in) * 100 / new_compare_pri).toFixed(0) + '%';

                      }

                  }
                  ));
              }));
          }
          initATC() {
              let {
                  form: e,
                  atcButton: t
              } = this.elms;
              void 0 !== e && e.addEvent("submit", (n => {
                  n.preventDefault(), t.hasClass("has-pending") || t.insertAdjacentHTML("beforeend", '<svg class="svg-loading" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="margin: auto; background: none; shape-rendering: auto;" width="28px" height="28px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid"><circle cx="50" cy="50" fill="none" stroke="var(--main-color)" stroke-width="5" r="35" stroke-dasharray="164.93361431346415 56.97787143782138">  <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="1s" values="0 50 50;360 50 50" keyTimes="0;1"></animateTransform></circle></svg>'), t.addClass("pending", "has-pending"), Cart.add(e).finally((() => {
                      t.removeClass("pending")
                  }))
              }));
          }
          initQuickView() {
              let {
                  quickViewButton: e
              } = this.elms;
              e && e.addEvent("click", (function() {
                  let {
                      productHandle: e,
                      productVariantId: f
                  } = this.dataset;
                  this.addClass("pending");
                  let t = [];
                  t.push(AT.loadPopupQuickView()), t.push(AT.productsViewedQuickly[e] ? AT.productsViewedQuickly[e] : fetch(`/products/${e}?variant=${f}&view=ajax-quick-view`, {
                      dataType: "text"
                  })), Promise.all(t).then((t => {
                      t[0] ? (PopupQuickView.open(t[1]), AT.productsViewedQuickly[e] = t[1]) : console.log("An error occurred while loading quick view")
                  })).finally((() => this.removeClass("pending")))
              }))
          }
      }








      class f extends HTMLElement {
          constructor() {
              super(), this.sliderContainer = this.querySelector(".js-slider-container"), this.config = Object.assign(JSON.parse(this.querySelector("[data-tns-config]").innerHTML), {
                  onInit: () => {
                      this.sliderContainer.addClass("slider-initialized")
                  }
              })
          }
          init(e = {}) {
              try {
                  return this.slider = tns(Object.assign({
                      ...this.config
                  }, e))
              } catch (e) {
                  console.log(this), console.error(e)
              }
          }
          destroy() {
              this.slider.destroy()
          }
          goTo(e) {
              try {
                  this.slider.goTo(e)
              } catch (e) {
                  console.log(this), console.warn(e)
              }
          }
          play() {
              try {
                  this.slider.play()
              } catch (e) {
                  console.log(this), console.warn(e)
              }
          }
          pause() {
              try {
                  this.slider.pause()
              } catch (e) {
                  console.log(this), console.warn(e)
              }
          }
          getConfig() {
              return this.config
          }
      }
      class y extends HTMLElement {
          constructor() {
              super(), this.elms = {
                  triggerElement: this.querySelector("collapse-panel-header"),
                  expansionElement: this.querySelector("collapse-panel-content")
              }, this.initEvent(), this.initContentObserverEventHandler()
          }
          initEvent() {
              let {
                  triggerElement: e,
                  expansionElement: t
              } = this.elms;
              this.hasAttribute("open") && t.css("height", t.firstElementChild.offsetHeight + "px"), e.addEvent("click", (() => {
                  this.hasAttribute("open") ? this.close() : this.open()
              }))
          }
          open() {
              let {
                  expansionElement: e
              } = this.elms;
              this.setAttribute("open", "");
              let t = e.firstElementChild.offsetHeight;
              e.css("height", t + "px")
          }
          close() {
              let {
                  expansionElement: e
              } = this.elms;
              this.removeAttribute("open"), e.css("height", "")
          }
          initContentObserverEventHandler() {
              let {
                  expansionElement: e
              } = this.elms;
              new MutationObserver(this.open.bind(this)).observe(e, {
                  childList: !0,
                  subtree: !0
              }), window.addEvent("resize", this.open.bind(this))
          }
      }
      class w extends HTMLElement {
          constructor() {
              super();
              let e = this.querySelector("quantity-input-minus"),
                  t = this.querySelector("quantity-input-plus"),
                  n = this.querySelector("input[name='quantity']"),
                  o = +n.min;
              e.addEvent("click", (() => {
                  let {
                      value: e
                  } = n;
                  --e, n.value = e > 1 ? e : 1, n.dispatchEvent(new Event("input"))
              })), t.addEvent("click", (() => {
                  let {
                      value: e
                  } = n;
                  n.value = ++e, n.dispatchEvent(new Event("input"))
              })), n.addEvent("input", AT.debounce((() => {
                  "function" == typeof this.callback && n.value >= o && this.callback(n.value)
              }), 500))
          }
          onChange(e) {
              this.callback = e
          }
      }
      HTMLElement;
      class g extends HTMLElement {
          constructor() {
              super(), this.getElementsByClassName("js-popup-close").addEvents("click", this.close.bind(this))
          }
          close() {
              this.removeClass("is-open"), AT.enableScroll()
          }
          open() {
              this.addClass("is-open"), AT.disableScroll()
          }
      }
      class v extends g {
          constructor() {
              super()
          }
          open(e) {
              this.addClass("is-open"), this.querySelector(".js-message").innerHTML = e, AT.disableScroll()
          }
      }
      let b = {
              onLoad() {
                  let {
                      container: e
                  } = this;
                  try {
                      this.slider = e.querySelector("slider-component").init()
                  } catch (t) {
                      console.log(e), console.warn(t)
                  }
              }
          },
          C = {
              onLoad() {
                  let {
                      container: e
                  } = this;
                  try {
                      AT.detectVisible({
                          element: e,
                          rootMargin: "0px",
                          callback() {
                              e.querySelector("slider-component").init()
                          }
                      })
                  } catch (t) {
                      console.log(e), console.error(t)
                  }
              }
          },
          E = {
              onLoad() {
                  let {
                      container: e
                  } = this;
                  try {
                      AT.detectVisible({
                          element: e,
                          rootMargin: "0px",
                          callback() {
                              e.querySelector("slider-component").init()
                          }
                      })
                  } catch (t) {
                      console.log(e), console.error(t)
                  }
              }
          },
          S = {
              onLoad() {
                  let {
                      container: e
                  } = this;
                  try {
                      AT.detectVisible({
                          element: e,
                          rootMargin: "0px",
                          callback() {
                              let e = document.getElementById("slideshow-media-main"),
                                  t = document.getElementById("slideshow-three-products");
                              e.init(), t && t.init()
                          }
                      })
                  } catch (t) {
                      console.log(e), console.error(t)
                  }
              }
          },
          k = {
              onLoad() {
                  let {
                      container: e
                  } = this;
                  this.config = {
                      sticky: "true" === e.dataset.sticky,
                      verticalSelected: false
                  }, this.elms = {
                      mobileDrawerInput: this.container.querySelector("#mobile-drawer-input"),
                      dropdownCartTemplate: this.container.querySelector("#dropdown-cart-template"),
                      headerCartIconDesktop: this.container.getElementsByClassName("js-header-cart-icon--desktop"),
                      headerCartIconDesMob: document.getElementsByClassName("js-header-cart-icon--desktop"),
                      headerCartIconMobile: this.container.querySelector(".js-header-cart-icon--mobile")
                  }, "true" === e.dataset.sticky && this.initSticky(), this.inittoggleMenu(), e.querySelectorAll('.header-bottom_vertical-menu').length > 0 && this.initVerticalDropdown(), this.initDrawer(), this.initCartIcons(), this.initDropdownCart(), this.initChangeImage(), this.initCountdown()
              },
              initVerticalDropdown() {
                  let e = document.querySelector(".vertical-menu-head");
                  let item_all = document.querySelector('.header-bottom_vertical-menu.vertical-nav.desk-lazy-menu');
                  e.addEvent("mouseover", (function() {
                    e.addClass("open");
                      document.querySelector(".header-vertical-menu").addClass("open");
                  }))
                  item_all.addEvent("mouseleave", (function() {
                      document.querySelector(".header-vertical-menu").removeClass("open");
                      e.removeClass("open");
                  }))

              },
              inittoggleMenu() {
                  let e = document.querySelector(".off-canvas-navigation-wrapper"),
                      t = document.querySelector("#main-content");
                  e && (e.addEvent("click", (t => {
                      e.addClass("toggled"), document.querySelector("body").addClass("off-canvas-active")
                  })), t.addEvent("click", (t => {
                      e.removeClass("toggled"), document.querySelector("body").removeClass("off-canvas-active")
                  })))
              },
              initDropdownCart() {
                  let {
                      headerCartIconDesktop: e,
                      headerCartIconDesMob: m,
                      headerCartIconMobile: t,
                      dropdownCartTemplate: n
                  } = this.elms;

                  function o(e) {
                      this.dropdownCart.inserted || (this.dropdownCart.inserted = !0), e.insertAdjacentElement("afterend", this.dropdownCart.container)
                  }

                  function i() {
                      e[0].addEvent("click", (t => {
                          document.querySelector("body").hasClass("cart-type-page") || (t.preventDefault(), t.stopPropagation(), this.dropdownCart.inserted || o.call(this, e[0]), this.dropdownCart.container.closest(".header-cart").addClass("active"), document.querySelector("body").addClass("cart-active"))
                      }))
                  }

                  function p() {
                      m[0].addEvent("click", (t => {
                          document.querySelector("body").hasClass("cart-type-page") || (t.preventDefault(), t.stopPropagation(), this.dropdownCart.inserted || o.call(this, m[0]), this.dropdownCart.container.closest(".header-cart").addClass("active"), document.querySelector("body").addClass("cart-active"))
                      }))
                  }
                  n && (this.dropdownCart = {
                      inserted: !1,
                      container: n.content.firstElementChild
                  }, Object.assign(this.dropdownCart, {
                      elms: {
                          lineItemListContainer: this.dropdownCart.container.querySelector(".js-cart-line-item-list"),
                          cartTotal: this.dropdownCart.container.querySelector(".js-cart-total")
                      },
                      setItemCount(e) {
                          this.container.setAttribute("data-cart-item-count", e)
                      document.querySelector('.js-cart-item-count').innerText=e;
                      },
                      highlightNewAddedItem(e) {
                          let {
                              lineItemListContainer: t
                          } = this.elms, n = [...t.children].find((t => t.dataset.key == e.key));
                          n && (n.addClass("line-item--highlight"), t.scrollTo(0, n.offsetTop), AT.debounce((() => n.removeClass("line-item--highlight")), 1e3)())
                      }
                  }), this.dropdownCart.container.querySelector(".js-btn-close").addEvent("click", (() => {
                      this.dropdownCart.container.closest(".header-cart").removeClass("active"), document.querySelector("body").removeClass("cart-active")
                  })), document.querySelector("body").hasClass("cart-type-drawer") && this.dropdownCart.container.querySelector(".btn-close-cart").addEvent("click", (e => {
                      this.dropdownCart.container.closest(".header-cart").removeClass("active"), document.querySelector("body").removeClass("cart-active")
                  })), this.dropdownCart.container.querySelectorAll(".js-cart-line-item").forEach(this.initDropdownCartLineItem.bind(this)), window.addEvent("resize", (async () => {
                      this.dropdownCart.inserted && window.innerWidth >= 992 ? o.call(this, e[0]) : o.call(this, m[0])
                  })), e.length ? i.call(this) : p.call(this), document.addEvent("click", (e => {
                      !this.dropdownCart.container.contains(e.target) && this.dropdownCart.inserted && (this.dropdownCart.container.closest(".header-cart").removeClass("active"), document.querySelector("body").removeClass("cart-active"))
                  })), document.addEvent("cart-add", (({
                      detail: n
                  }) => {
                      this.dropdownCart.inserted || o.call(this, window.innerWidth >= 992 ? e[0] : m[0]), this.updateDropdownCart("add", n), window.innerWidth < 992 || document.querySelector(".js-header-cart-icon--desktop").hasClass("effect-popup") ? document.querySelector("#cart-message").addClass("is-open") : document.querySelector(".js-header-cart-icon--desktop").click()
                  })), document.querySelector(".popup-cart-close").addEvent("click", (e => {
                      document.querySelector("#cart-message").removeClass("is-open")
                  })), document.querySelector(".js-cart-popup-close").addEvent("click", (e => {
                      document.querySelector("#cart-message").removeClass("is-open")
                  })))
              },
              updateDropdownCart(e, t) {
                  let {
                      lineItemListContainer: n,
                      cartTotal: o
                  } = this.dropdownCart.elms;
                  switch (e) {
                      case "remove":
                          this.dropdownCart.container.setAttribute("data-cart-item-count", t.item_count), this.dropdownCart.container.setAttribute("data-cart-item-count", t.item_count), o.innerHTML = t.total_price.toCurrency();
                          break;
                      case "add": {
                          let {
                              sections: e,
                              ...i
                          } = t, s = document.createElement("div");
                          s.innerHTML = e["ajax-cart"];
                          n.innerHTML = s.querySelector("#shopify-section-ajax-cart").innerHTML;
                          let r = JSON.parse(s.querySelector("[data-cart-json]").innerHTML);
                          [...n.children].find((e => {
                            if (e.tagName !== 'SCRIPT') {
                              this.initDropdownCartLineItem(e);
                            }
                          }));
                          o.innerHTML = r.total_price.toCurrency(), this.dropdownCart.setItemCount(r.item_count);
                          break
                      }
                  }
              },
              initDropdownCartLineItem(e) {
                  let t = e.querySelector(".js-btn-remove"),
                      {
                          key: n
                      } = e.dataset;
                  t.addEvent("click", (o => {
                  console.log(n, 'this is n');
                      o.preventDefault(), t.innerHTML = theme.strings.header.dropdownCart.removing, Cart.remove(n).then((t => {
                          e.remove(), this.updateDropdownCart("remove", t)
                      }))
                  }))
              },
              initSticky() {
                  let {
                      container: e
                  } = this, t = e.offsetHeight, n = e.offsetHeight;
                  let last_known_scroll_position = 0;
                  let ismhb_show = true;
                  let isSticky = false;
                  let ticking = false;
                  document.documentElement.style.setProperty("--header-height", n + "px"), window.pageYOffset > t && (e.addClass("header-sticky"), e.css("height", n + "px")), window.addEvent("scroll", (() => {
                      window.pageYOffset > t ? (e.addClass("header-sticky"), e.css("height", n + "px"), isSticky = true) : window.pageYOffset <= e.offsetTop && (e.removeClass("header-sticky"), e.css("height", ""), isSticky = false)
                  })), window.addEvent("resize", (() => {
                      n = e.offsetHeight, t = e.offsetHeight, document.documentElement.style.setProperty("--header-height", n + "px"), document.dispatchEvent(new CustomEvent("header-height-change", {
                          detail: n + "px"
                      }))
                  })),
                  // if scroll direction is down then hide header bottom. if scroll direction is up then show header bottom
                  // debounce event
                  window.addEventListener("scroll", function () {
                    if (isSticky) {
                      let previous_known_scroll_position = last_known_scroll_position;
                      last_known_scroll_position = window.scrollY;
                      if (!ticking) {
                        window.requestAnimationFrame(function () {
                          if (previous_known_scroll_position > last_known_scroll_position) {
                            if (!ismhb_show) {
                              document.querySelector('.header-sticky .header-mobile_bottom').addClass('mhb-show');
                              ismhb_show = true;
                            }
                          } else {
                            if (ismhb_show) {
                              document.querySelector('.header-sticky .header-mobile_bottom').removeClass('mhb-show');
                              ismhb_show = false;
                            }
                          }
                          ticking = false;
                        });
                        ticking = true;
                      }
                    }
                  });
              },
              initDrawer() {
                  let {
                      mobileDrawerInput: e
                  } = this.elms, t = this.container.querySelector("#header-mobile-drawer-wrapper"), n = document.createElement("div"),
                  menu_open = false, delayTimeout = null, menu_to_open = null, menu_list = document.querySelector(".header-menu .menu-list");
                  n.innerHTML = t.innerHTML, e.addEvent("input", (() => {
                      t.insertAdjacentElement("beforebegin", n.firstElementChild), t.remove()
                  }), {
                      once: !0
                  }), e.addEvent("input", (function() {
                      this.checked ? AT.disableScroll() : AT.enableScroll(), this.checked ? document.querySelector("body").addClass("mobile-menu-active", "show-shadow") : document.querySelector("body").removeClass("mobile-menu-active", "show-shadow"), document.querySelectorAll(".menu-checkbox-mobile").forEach((function(e) {
                          e.addEventListener("change", (function() {
                              this.checked ? (this.closest(".menu-mobile-item").addClass("active"), document.querySelector(".menu-mobile-list").addClass("sub-open")) : (this.closest(".menu-mobile-item").removeClass("active"), document.querySelector(".menu-mobile-list").removeClass("sub-open"))
                          }))
                      })), document.querySelectorAll(".menu-checkbox-mobile-2").forEach((function(e) {
                          e.addEventListener("change", (function() {
                              this.checked ? (this.closest(".menu-mobile-item-2").addClass("active"), this.closest(".menu-mobile-list--lv1").addClass("sub-open")) : (this.closest(".menu-mobile-item-2").removeClass("active"), this.closest(".menu-mobile-list--lv1").removeClass("sub-open"))
                          }))
                      }))
                  })), document.querySelectorAll(".mega-menu-item").forEach(((e) => {
                    e.addEventListener("mouseover", (event) => {
                      let tempElement = event.currentTarget.querySelector(".temp-id");
                      if (tempElement) {
                          let newDiv = document.createElement("div");
                          newDiv.innerHTML = tempElement.innerHTML;
                          tempElement.insertAdjacentElement("afterend", newDiv.firstElementChild);
                          tempElement.remove();

                          const masonryElems = event.currentTarget.querySelectorAll('.mega-menu-div-one');

                          masonryElems.forEach((masonryElem) => {
                            new Masonry(masonryElem, {
                                itemSelector: '.grid-item',
                                horizontalOrder: true,
                                percentPosition: true
                            });
                          });

                          let verticalMenu = event.currentTarget.querySelector(".vertical-menu");
                          if (verticalMenu) {
                              const heights = [...event.currentTarget.querySelectorAll('.mega-menu-div-one')].map(el => el.clientHeight);
                              const minHeight = event.currentTarget.querySelector('.vertical-menu--left').clientHeight;
                              const maxHeight = Math.max(...heights, (minHeight + 40));
                              event.currentTarget.querySelector('.mega-menu .vertical-menu--content').style.height = `${maxHeight}px`;

                              let menuTitles = verticalMenu.querySelectorAll('.vertical-menu--left .menu-title');
                              menuTitles.forEach((title, index) => {
                                  if (index === 0) {
                                      title.classList.add("open");
                                      this.config.verticalSelected = title.dataset.id;
                                      document.getElementById(this.config.verticalSelected).classList.add("open");
                                  }

                                  title.addEventListener("mouseover", (mouseOverEvent) => {
                                      if (this.config.verticalSelected) {
                                          document.getElementById(`${this.config.verticalSelected}-title`).classList.remove("open");
                                          document.getElementById(this.config.verticalSelected).classList.remove("open");
                                      }
                                      mouseOverEvent.currentTarget.classList.add("open");
                                      this.config.verticalSelected = mouseOverEvent.currentTarget.dataset.id;
                                      document.getElementById(this.config.verticalSelected).classList.add("open");
                                  });
                              });
                          } else {

                          }
                      }
                    });
                  }));

                  document.querySelectorAll(".menu-item").forEach((function(e) {
                     e.addEventListener("mouseover", (function(ele) {
                      const mega_menu_element = e.querySelector('.mega-menu');
                      menu_to_open = ele.currentTarget;
                      if (menu_open) {
                        ele.currentTarget.addClass("open");
                        if(mega_menu_element)
                          $('body').addClass('show-shadow');
                      }
                    })),
                    e.addEventListener("mouseleave", (function(ele) {
                      const mega_menu_element = e.querySelector('.mega-menu');
                        ele.currentTarget.removeClass("open");
                        if(mega_menu_element)
                          $('body').removeClass('show-shadow');
                    }))
                }));
                  if (menu_list) {
                    menu_list.addEventListener("mouseover", (function() {
                      if (!menu_open && delayTimeout === null)
                      delayTimeout = setTimeout(() => {
                        menu_open = true;
                        menu_to_open.dispatchEvent(new MouseEvent('mouseover', { 'view': window, 'bubbles': true, 'cancelable': true }));
                      },200);
                    })),
                    menu_list.addEventListener("mouseleave", (function() {
                      clearTimeout(delayTimeout);
                      delayTimeout = null;
                      menu_open = false;
                    }));

                  }
              },
              initCartIcons() {
                  let e = this.container.getElementsByClassName("js-cart-item-count"),
                      t = this.container.getElementsByClassName("js-cart-item-total");
                  document.addEvent("cart-change", (({
                      detail: n
                  }) => {
                      [...e].forEach((e => e.innerHTML = n.item_count)), [...t].forEach((e => e.innerHTML = n.total_price.toCurrency()))
                  })), window.addEvent("resize", (() => {
                      [...e].forEach((e => e.innerHTML = Cart.item_count)), [...t].forEach((e => e.innerHTML = Cart.total_price.toCurrency()))
                  }))
              },
              initChangeImage() {
                  let e = document.querySelectorAll(".img-swt-temp");
                  e && e.forEach((function(e) {
                      e.addEvent("click", (function() {
                          let t = e.querySelector("img").getAttribute("srcset"),
                              n = e.querySelector("img").getAttribute("data-srcset"),
                              o = e.closest(".product-card").querySelector(".wrap-image img");
                          o.setAttribute("data-srcset", n), o.setAttribute("srcset", t)
                      }))
                  }))
              },
              initCountdown() {
                  let e = document.querySelectorAll(".product-countdown");
                  e && e.forEach((function(e) {
                      let t = e.getAttribute("data-duedate-year"),
                          n = e.getAttribute("data-duedate-month"),
                          o = e.getAttribute("data-duedate-day"),
                          i = new Date(t, n - 1, o).getTime(),
                          s = setInterval((function() {
                              let t = (new Date).getTime(),
                                  n = i - t,
                                  o = Math.floor(n / 864e5),
                                  r = Math.floor(n % 864e5 / 36e5 + 24 * o),
                                  a = Math.floor(n % 36e5 / 6e4),
                                  c = Math.floor(n % 6e4 / 1e3);
                              e.querySelector(".countdown-html").innerHTML = "<span class='countdown-section'><span class='countdown-value'>" + r + "</span><span class='countdown-text'>hours</span></span> <span class='countdown-section'><span class='countdown-value'>" + a + "</span><span class='countdown-text'>minutes</span></span> <span class='countdown-section'><span class='countdown-value'>" + c + "</span><span class='countdown-text'>seconds</span></span>", n < 0 && (clearInterval(s), e.closest(".product-countdown").addClass("d-none"))
                          }), 1e3)
                  }))
              }
          };
      let T = {
          get: function(e) {
              var t = document.cookie.match("(^|;) ?" + e + "=([^;]*)(;|$)");
              return t ? JSON.parse(t[2]) : null
          },
          set: function(e, t, n) {
              var o = new Date;
              o.setTime(o.getTime() + 24 * n * 60 * 60 * 1e3), document.cookie = e + "=" + JSON.stringify(t) + ";expires=" + o.toUTCString() + ";path=/"
          },
          delete: function(e) {
              var t = this.get(e);
              this.set(e, t, "-1")
          }
      };
      Object.assign(window, {
              load: a,
              register: r,
              Cart: new class {
                  constructor() {
                      this.settings = {
                          ...theme.settings.cart
                      }, this.get()
                  }
                  addMutiple(e) {
                      return fetch(theme.routes.cartAdd, {
                          method: "post",
                          headers: new Headers({
                              "Content-type": "application/json"
                          }),
                          body: JSON.stringify({
                              items: [...e]
                          }),
                          dataType: "json"
                      }).then((e => this.get().then((async () => {
                          let {
                              items: t
                          } = e;
                          if ("drawer" === this.settings.type) return this.drawer ? (this.drawer.isLoaded ? (document.dispatchEvent(new CustomEvent("cart-add", {
                              detail: e
                          })), this.get().then((e => document.dispatchEvent(new CustomEvent("cart-change", {
                              detail: e
                          }))))) : await this.drawer.load(), e) : e
                      })))).catch((e => (e.then((e => {
                          this.drawer && this.drawer.isOpen ? (this.drawer.close(), alert(e.description)) : alert(e.description)
                      })), e)))
                  }
                  add(e) {
                      let t = new FormData(e);
                      return "cart" == theme.template ? (t.append("sections", "cart-template"), t.append("sections_url", theme.routes.searchUrl)) : t.append("sections", "ajax-cart"), fetch(theme.routes.cartAdd, {
                          method: "post",
                          headers: new Headers({
                              "X-Requested-With": "XMLHttpRequest"
                          }),
                          body: t,
                          dataType: "json"
                      }).then((e => {
                          document.dispatchEvent(new CustomEvent("cart-add", {
                              detail: e
                          })), this.get().then((e => document.dispatchEvent(new CustomEvent("cart-change", {
                              detail: e
                          }))))
                      }))
                  }
                  get() {
                      return fetch(theme.routes.cartGet, {
                          dataType: "json"
                      }).then((e => Object.assign(this, e)))
                  }
                  clear() {
                      return fetch(theme.routes.cartClear, {
                          dataType: "json"
                      }).then((e => (this.value = e, e)))
                  }
                  change(e, t) {
                      return fetch(theme.routes.cartChange, {
                          method: "post",
                          body: JSON.stringify({
                              id: e,
                              quantity: t
                          }),
                          headers: {
                              "Content-Type": "application/json"
                          },
                          dataType: "json"
                      }).then((e => (this.value = e, e)))
                  }
                  remove(e) {
                      const v = JSON.stringify({
                        id: e,
                        quantity: 0
                    });
                    console.log("Cart Remove: ", v);
                      return fetch(theme.routes.cartChange, {
                          method: "post",
                          headers: new Headers({
                              "Content-Type": "application/json"
                          }),
                          dataType: "json",
                          body: v
                      }).then((e => (this.value = e, document.dispatchEvent(new CustomEvent("cart-change", {
                          detail: e
                      })), e)))
                  }
              },
              AT: {
                  searchLoaded: !1,
                  detectVisible: ({
                      element: e,
                      rootMargin: t,
                      callback: n,
                      threshold: o = 0
                  }) => {
                      if ("undefined" == typeof IntersectionObserver) return void n();
                      new IntersectionObserver(((t, o) => {
                          t.forEach((t => {
                              t.isIntersecting && (n(), o.unobserve(e))
                          }))
                      }), {
                          rootMargin: t
                      }).observe(e)
                  },
                  initTabPanel: e => {
                      try {
                          let t = e.querySelector(".js-nav-controls"),
                              n = e.querySelector(".js-tab-contents");
                          [...t.children].forEach((e => {
                              let o = n.querySelector(e.dataset.target);
                              e.addEvent("click", (() => {
                                  e.hasClass("active") || (t.children.removeClass("active"), n.children.removeClass("active"), e.addClass("active"), o.addClass("active"))
                              }))
                          }))
                      } catch (t) {
                          console.warn("Has an error from Tab Panel function:", t), console.log(e)
                      }
                  },
                  disableScroll: function() {
                      let e = window.innerWidth - document.documentElement.offsetWidth + "px";
                      document.documentElement.style.paddingRight = e, document.documentElement.addClass("overflow-hidden")
                  },
                  enableScroll: function() {
                      document.documentElement.style.paddingRight = "", document.documentElement.removeClass("overflow-hidden")
                  },
                  debounce: (e, t) => {
                      let n;
                      return function(...o) {
                          clearTimeout(n), n = setTimeout((() => {
                              clearTimeout(n), e(...o)
                          }), t)
                      }
                  },
                  loadScript: (e, t) => {
                      let n = document.createElement("script");
                      n.src = e, t && (n.onload = t), n.onError = () => {
                          console.warn("Has an error when loading script:", e)
                      }, document.body.append(n)
                  },
                  loadCss: (e, t) => {
                      let n = document.createElement("link");
                      n.href = e, n.rel = "stylesheet", n.as = "style", t && (n.onload = t), n.onError = () => {
                          console.warn("Has an error when loading link:", e)
                      }, document.head.append(n)
                  },
                  loadSearch: function() {
                      return new Promise(((e, t) => {
                          AT.searchLoaded ? t(0) : AT.loadScript(theme.assets.search, (() => {
                              AT.searchLoaded = !0, e(1)
                          }))
                      }))
                  },
                  getParameterByName: function(e, t = window.location.href) {
                      e = e.replace(/[\[\]]/g, "\\$&");
                      var n = new RegExp("[?&]" + e + "(=([^&#]*)|&|#|$)").exec(t);
                      return n ? n[2] ? decodeURIComponent(n[2].replace(/\+/g, " ")) : "" : null
                  },
                  getSizedImageUrl: h,
                  scrollTo: function(e, t, n = 0) {
                      return new Promise(((o, i) => {
                          var s, r, a = window.pageYOffset,
                              c = ("number" == typeof(s = e) ? s : window.pageYOffset + s.getBoundingClientRect().top) - n,
                              l = (document.body.scrollHeight - c < window.innerHeight ? document.body.scrollHeight - window.innerHeight : c) - a;
                          if (!l) return o(1);
                          window.requestAnimationFrame((function e(n) {
                              r || (r = n);
                              var i, s = n - r,
                                  c = Math.min(s / t, 1);
                              c = (i = c) < .5 ? 4 * i * i * i : (i - 1) * (2 * i - 2) * (2 * i - 2) + 1, window.scrollTo(0, a + l * c), s < t ? window.requestAnimationFrame(e) : o(1)
                          }))
                      }))
                  },
                  queue: new class {
                      constructor() {
                          this.queue = [], this.running = !1
                      }
                      add(e, t) {
                          this.queue.push([e, t]), this.running || this.next()
                      }
                      next() {
                          if (this.running = !1, this.test) return;
                          let [e, t] = this.queue.shift() || [void 0, void 0];
                          return e ? "function" == typeof e.then ? (this.running = !0, e.then((e => (t && t(e), this.next(), e)))) : (this.running = !0, new Promise(((t, n) => t(e))).then((e => (t && t(e), this.next(), e)))) : void 0
                      }
                  },
                  cookie: T,
                  loadPopupMessage: function() {
                      return new Promise(((e, t) => {
                          if (void 0 !== window.PopupMessage) return void e(1);
                          let n = document.getElementById("popup-container"),
                              o = n.content.querySelector("popup-message");
                          return o ? (n.insertAdjacentElement("beforebegin", o), customElements.define("popup-message", v), window.PopupMessage = o, Popups.push("popup-message", window.PopupMessage), e(1)) : t(0)
                      }))
                  },
                  loadPopupQuickView: function() {
                      return new Promise(((e, t) => {
                          if (void 0 !== window.PopupQuickView) return e(1);
                          AT.loadScript(theme.assets.popupQuickView, (() => {
                              e(1)
                          }))
                      }))
                  },
                  loadPopupStoreLocation: function() {
                      let e = [new Promise(((e, t) => {
                          AT.loadCss(theme.assets.mapboxCss, (() => {
                              e(1)
                          }))
                      })), new Promise(((e, t) => {
                          AT.loadScript(theme.assets.mapboxJs, (() => {
                              e(1)
                          }))
                      })), new Promise(((e, t) => {
                          AT.loadScript(theme.assets.storeLocationPopup, (() => {
                              e(1)
                          }))
                      }))];
                      return Promise.all(e)
                  },
                  initCustomElements(e) {
                      switch (e) {
                          case "slider-component":
                              customElements.define(e, f);
                              break;
                          case "collapse-panel":
                              customElements.define(e, y)
                      }
                  },
                  productsViewedQuickly: {}
              }
          }), window.Popups = new class {
              constructor() {
                  this.list = {}
              }
              open(e) {
                  this.list[e] && this.list[e].open()
              }
              close(e) {
                  this.list[e] && this.list[e].close()
              }
              closeAll() {
                  Object.keys(this.list).forEach((e => this.list[e].close()))
              }
              push(e, t) {
                  this.list[e] = t
              }
              get(e) {
                  return this.list[e]
              }
          }, window.PopupComponent = g, theme.customElementsList && [...new Set(theme.customElementsList)].forEach((e => {
              switch (e) {
                  case "slider-component":
                      customElements.define(e, f);
                      break;
                  case "collapse-panel":
                      customElements.define(e, y)
              }
          })), customElements.define("product-card", m), customElements.define("quantity-input", w), r("header", k), theme.sectionRegister && theme.sectionRegister.forEach((e => {
              switch (e) {
                  case "announcement-bar":
                      r("announcement-bar", b);
                      break;
                  case "featured-collection":
                      r("featured-collection", C);
                      break;
                  case "logo-list":
                      r("logo-list", E);
                      break;
                  case "featured-blog":
                      r("featured-blog", S)
              }
          })), a("*"), document.querySelectorAll("input[name='q']").addEvents("click", (() => AT.loadSearch()), {
              once: !0
          }), console.log("global.js loaded"), document.dispatchEvent(new CustomEvent("global.js loaded")),
          function() {
              let e = document.getElementById("back-to-top");
              e.addEvent("click", (() => {
                  AT.scrollTo(0, 1e3)
              })), window.addEvent("scroll", (() => {
                  window.pageYOffset > 1.5 * window.innerHeight ? (e.addClass("show"), document.body.addClass("show-back-to-top"))
                  : (e.removeClass("show"), document.body.removeClass("show-back-to-top"))
              }))
          }()
  })()
})();

